import { TableRowCell } from '@components/TableRowCell';
import { TableHeaderCell } from '@components/TableHeaderCell';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const TableCellsSection = () => {
  return (
    <section className={styles.section}>
      <SectionHeader
        title="Table Cells"
        description="Table cell components for building data tables. Includes header cells and row cells with primary/secondary variants."
        figmaNodeId="68-619"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Table Header Cell</h3>
        <p className={styles.hint} style={{ marginTop: 0, marginBottom: '16px' }}>
          Grey background, 40px height, metadata-medium typography.
        </p>
        <div className={styles.tableCellsContainer}>
          <TableHeaderCell title="Type Name" />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Table Row Cell - Primary</h3>
        <p className={styles.hint} style={{ marginTop: 0, marginBottom: '16px' }}>
          Primary cells show main content with optional metadata line below.
        </p>
        <div className={styles.tableCellsContainer}>
          <TableRowCell text="Dental Clinic" />
          <TableRowCell text="Dermatology" metadata="Updated 15 Dec 2024" showMeta />
          <TableRowCell text="Very Long Business Type Name That Should Truncate" />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Table Row Cell - Secondary</h3>
        <p className={styles.hint} style={{ marginTop: 0, marginBottom: '16px' }}>
          Secondary cells are right-aligned and used for values like counts.
        </p>
        <div className={styles.tableCellsContainer}>
          <TableRowCell text="187" type="secondary" />
          <TableRowCell text="1,234" type="secondary" />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Complete Table Row Example</h3>
        <p className={styles.hint} style={{ marginTop: 0, marginBottom: '16px' }}>
          Combining header and row cells to create a table structure.
        </p>
        <div className={styles.tableCellsContainer}>
          <div className={styles.tableRow}>
            <TableHeaderCell title="Type Name" className={styles.tableCellPrimary} />
            <TableHeaderCell title="Leads" className={styles.tableCellSecondary} />
          </div>
          <div className={styles.tableRow}>
            <TableRowCell text="Dental Clinic" className={styles.tableCellPrimary} />
            <TableRowCell text="187" type="secondary" className={styles.tableCellSecondary} />
          </div>
          <div className={styles.tableRow}>
            <TableRowCell
              text="Dermatology"
              metadata="Updated 15 Dec 2024"
              showMeta
              className={styles.tableCellPrimary}
            />
            <TableRowCell text="142" type="secondary" className={styles.tableCellSecondary} />
          </div>
          <div className={styles.tableRow}>
            <TableRowCell text="Eye Clinic" className={styles.tableCellPrimary} />
            <TableRowCell text="98" type="secondary" className={styles.tableCellSecondary} />
          </div>
        </div>
      </div>
    </section>
  );
};
